import { useState, useRef } from 'react'
import styled from 'styled-components'
import BottomSheetLayout from '../common/BottomSheetLayout'
import Text from '../../atoms/Text'

const TextWrapper = styled.div`
  margin-top: 16px;
`
const Wrapper = styled.div`
  overflow: hidden;
  max-height: 600px;
  margin-top: 28px;
`
const SlideWrapper = styled.div`
  height: 280px;
  text-align: left;
  transition-duration: 300ms;
  transition-timing-function: ease-out; // 점점 느려짐
  display: flex;
  flex-direction: column;
  li {
    list-style-type: none;
    user-select: none;
    cursor: pointer;
    padding: 16px 0;
  }
}
`

const LanguageDisorderBottomSheet = ({ $isOpen, onClose, onChangeDisorder }) => {
  
  const datas = ['언어 발달 지체', '단순 언어 장애', '조음/음운 장애', '유창성장애', '음성장애']
  const [startY, setStartY] = useState(0) // 첫 터치 시작 위치
  const [moveY, setMoveY] = useState(0) // 스크롤한 거리
  const [prevY, setPrevY] = useState(0) // 이전 이동 거리

  const ref = useRef(null) // DOM element에 직접 접근하기 위해 ref 사용
  const itemRef = useRef(null)
  const [isDragging, setIsDragging] = useState(false) // 드래그 여부 

  // 스크롤 시작 X좌표 저장
  const handleTouchStart = (event) => {
    event.touches ? setStartY(event.touches[0].clientY) : setStartY(event.clientY)
    setIsDragging(true)
  };

  // 스크롤 중 슬라이더의 이동거리 계산
  const handleTouchMove = (event) => {
    if (!isDragging) return
    const currentY= event.touches ? event.touches[0].clientY : event.clientY
    const distanceY = currentY - startY + prevY // 이동 거리 = 스크롤 한 위치 - 시작 위치 + 이전 이동 거리
    const maxScroll = ref.current.scrollHeight - ref.current.clientHeight// 최대 스크롤 가능 거리 
    // console.log("scrollHeight:", ref.current.scrollHeight); // 확인용
    // console.log("clientHeight:", ref.current.clientHeight); // 확인용
    // console.log("distanceY:", distanceY)
    // distance의 값은 오른쪽으로 스크롤하면 양수, 왼쪽으로 스크롤하면 음수
    let newMoveY // setMoveX가 비동기로 이루어져 moveX를 즉시 반영 못하는 문제가 발생하는 것을 방지
    if (distanceY > 0) {
      newMoveY = 0
      setMoveY(0); // 첫 슬라이드에서 더 이동하지 않음
    } else if (Math.abs(distanceY) > maxScroll) {
      newMoveY = -maxScroll
      setMoveY(-maxScroll); // 마지막 슬라이드에서 더 이동하지 않음
    } else {
      newMoveY = distanceY
      setMoveY(distanceY); // 계산된 이동 거리를 상태변수에 담아두기
    }
    setMoveY(newMoveY);
    ref.current.style.transform = `translateY(${newMoveY}px)`; // 스크롤한 거리만큼 이동
  };

  // 스크롤이 끝나며 이동 거리를 이전 이동 거리 변수로 저장, 다음 이동 거리 계산 시 사용
  const handleTouchEnd = () => {
    if (!isDragging) return;
    setPrevY(moveY)
    setIsDragging(false)
  }

  const handleSelectDisorder = (data) => {
    onChangeDisorder(data)
    onClose();
  }

  return (
    <BottomSheetLayout $isOpen={$isOpen} onClose={onClose}>
     <>
        <TextWrapper>
          <Text variant="headline2" weight="bold">언어 장애 유형을 선택해주세요.</Text>
        </TextWrapper>
        <Wrapper>
          <SlideWrapper 
            ref={ref}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            onMouseDown={handleTouchStart} // 마우스 버튼이 눌려지는 순간
            onMouseMove={handleTouchMove} // 커서가 움직이는 순간
            onMouseUp={handleTouchEnd} // 마우스 버튼이 떼지는 순간 
            onMouseLeave={handleTouchEnd} // 마우스가 벗어나는 순간
          >
            {
              datas.map((data) => (
                <li key={data}
                    ref={itemRef}
                    onClick={(e)=>{
                        e.stopPropagation();
                        handleSelectDisorder(data);
                    }}>
                      <Text 
                        variant="headline3" 
                        weight="medium"
                        color="alternative">{data}</Text>
                </li>
              )) 
            }
          </SlideWrapper>
        </Wrapper>
      </>
    </BottomSheetLayout>
  )
}

export default LanguageDisorderBottomSheet
